import * as types from "../types/kitchenDisplays"

const initialState = []

const kitchenDisplaysReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_KITCHEN_DISPLAY:
      return [...state, action.kitchenDisplay]
    case types.EDIT_KITCHEN_DISPLAY:
      return state.map((kd, kdIndex) =>
        kdIndex === action.kitchenDisplayIndex ?
          { ...kd, ...action.data } : kd
      )
    case types.DELETE_KITCHEN_DISPLAY:
      return state.filter((_, kdIndex) =>
        kdIndex !== action.kitchenDisplayIndex
      )
    default:
      return state
  }
}

export default kitchenDisplaysReducer